export default function Init() {
  return <div className="appInit">Inicjalizowanie aplikacji</div>;
}
